// The admin shell renders its own sidebar and owns the /admin routes.
export function isAdminShellPath(pathname: string): boolean {
  return pathname.startsWith("/admin");
}
